import { create } from 'zustand';

interface AimeiChatStore {
  isVisible: boolean;
  promptContext: string | null;
  setVisible: (visible: boolean) => void;
  setPromptContext: (context: string | null) => void;
  setPromptContextAndOpen: (context: string | null) => void;
  toggle: () => void;
}

export const useAimeiChatStore = create<AimeiChatStore>((set) => ({
  isVisible: true,
  promptContext: null,
  setVisible: (visible: boolean) => set({ isVisible: visible }),
  setPromptContext: (context: string | null) => set({ promptContext: context }),
  setPromptContextAndOpen: (context: string | null) => {
    set({ promptContext: context, isVisible: true });
    // Ensure the Voiceflow chat is opened if available
    if (window.voiceflow?.chat?.open && context) {
      window.voiceflow.chat.open();
    }
  },
  toggle: () => set((state) => ({ isVisible: !state.isVisible })),
}));

// Extend Window interface for TypeScript
declare global {
  interface Window {
    voiceflow?: {
      chat?: {
        load?: (options: {
          verify?: { projectID: string };
          url?: string;
          versionID?: string;
          userID?: string;
          launch?: {
            event: {
              type: string;
              payload: Record<string, string>;
            };
          };
          voice?: {
            url: string;
          };
          render?: {
            mode: string;
            target: HTMLElement;
          };
          user?: {
            name: string;
            image: string;
          };
          assistant?: {
            stylesheet: string;
          };
        }) => void;
        open?: () => void;
        close?: () => void;
        toggle?: () => void;
        interact?: (message: { type: string; payload: string }) => void;
      };
    };
  }
}
